import { translateDrawerLinks } from './aeMenuTranslations';

/**
 * Get AE-specific drawer links
 * Returns a filtered and customized list of drawer links for AE locales
 * 
 * @param {string} locale - The locale code (ae_ar or ae_en)
 * @returns {Array} Filtered array of drawer links for AE region
 */
function getAEDrawerLinks(locale) {
  const isArabic = locale === 'ae_ar';
  
  return [
    {
      label: isArabic ? 'Faraday X الرئيسية' : 'Faraday X Home',
      url: `/${locale}/fx/`,
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: isArabic ? 'Faraday Future الرئيسية' : 'Faraday Future Home',
      url: `/${locale}/`,
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: '',
      url: '',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: isArabic ? 'سيارة FF 91 2.0 Futurist aiFalcon' : 'FF 91 2.0 Futurist Alliance',
      url: `/${locale}/product/ff-91-Alliance/`,
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: isArabic ? 'تكنولوجيا FF aiHyper 6x4 Architecture 2.0' : 'FF aiHyper 6x4 Architecture 2.0',
      url: `/${locale}/aihyper-architecture/`,
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: '',
      url: '',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: 'CXC10',
      url: 'https://www.c10index.com/en/',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: '',
      url: '',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: isArabic ? 'الابتكار المشترك والمشاركة المشتركة لفا‌رادي فيوتشر' : 'Co-Creation',
      url: 'https://www.ff.com/us/ff-co-creation-and-co-sharing/',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: isArabic ? 'الموقع والفعاليات‌' : 'Live&Event',
      url: `/${locale}/live-and-events/`,
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: isArabic ? 'علاقات المستثمرين' : 'Investor Relations',
      url: 'https://investors.ff.com/',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: isArabic ? 'من نحن' : 'Contact Us',
      url: `/${locale}/contact-us/`,
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: '',
      url: '',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: 'United States(English)',
      url: 'https://www.ff.com/us/',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: '中国大陆(简体中文)',
      url: 'https://www.faradayfuturecn.com/cn/',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: 'UAE(English)',
      url: 'https://www.ff.com/ae_en/',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    },
    {
      label: 'UAE(اَلْعَرَبِيَّةُ)',
      url: 'https://www.ff.com/ae_ar/',
      loggedInLabel: '',
      loggedInLabelUrl: ''
    }
  ];
}

/**
 * Get locale-aware menu props
 * This function takes the base menu props and the current locale,
 * and returns menu props with appropriate translations applied
 * 
 * @param {Object} baseMenuProps - The base menu props object from window.MENU_PROPS or default
 * @param {string} locale - The locale code (e.g., 'ae_ar', 'ae_en', 'us', 'cn')
 * @returns {Object} Menu props with locale-appropriate translations
 */
export function getLocaleAwareMenuProps(baseMenuProps, locale) {
  if (!baseMenuProps) {
    return baseMenuProps;
  }

  // Clone the menu props to avoid mutating the original
  const menuProps = { ...baseMenuProps };

  // For AE locales, use custom filtered drawer links and update logo link
  if (locale === 'ae_ar' || locale === 'ae_en') {
    menuProps.drawerLinks = getAEDrawerLinks(locale);
    menuProps.logo_link = `/${locale}/`; // snake_case for menuProps
    menuProps.logoLink = `/${locale}/`;  // camelCase for Header2 component
  }

  return menuProps;
}
